import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { LinkComponent } from '@teamfoster/sdk/button';
import { MenuItem } from '@teamfoster/sdk/menu-ngrx';

@Component({
    selector: 'app-menu-button-cloud',
    imports: [LinkComponent, NgClass],
    templateUrl: './menu-button-cloud.component.html',
    styleUrl: './menu-button-cloud.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MenuButtonCloudComponent {
  menuItems = input<MenuItem[]>([]);
  cssClasses = input<string>('');
}
